export default "__VITE_ASSET__B2r_Us$F__"